import { IconName } from './icon';

export interface IconsMap {
  globalMap: Record<IconName, IconName>;
  specificMap: Record<string, IconName>;
}
